import { render, staticRenderFns } from "./edit-save-product.vue?vue&type=template&id=46a7c0e6&"
import script from "./edit-save-product.vue?vue&type=script&lang=ts&"
export * from "./edit-save-product.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports